import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { ApiErrorMessage, ApplicationLogo, clearCache } from "@advosys/component-advosys-react";
import { Box, CloseButton, DefaultButton, Dialog, Render, Spinner, Text } from "@advosys/component-react";
import { assertNever, today } from "@advosys/component-react-utils";
import { SpinnerSize } from "@fluentui/react";
import { cacheInformation, cacheInformationKeys } from "src/core";
import { useT } from "./about-dialog-i18n";
import { actions } from "./about-dialog-store";
const mapStateToProps = (state) => state.application.aboutDialog;
const AboutDialogBase = (props) => {
    const { loading, getAppServerVersionRequest, clear, onDismiss } = props;
    const { t } = useT();
    useEffect(() => {
        if (loading.state === "not-started") {
            getAppServerVersionRequest();
        }
        return () => {
            clear();
        };
    }, []);
    const clearAllCaches = useCallback(() => {
        for (const key of cacheInformationKeys) {
            clearCache(cacheInformation[key].cacheKey);
        }
    }, [cacheInformation, cacheInformationKeys]);
    return (_jsx(Dialog, { size: "small", header: _jsx(ApplicationLogo, { color: "themePrimary" }), onDismiss: onDismiss, footer: _jsx(CloseButton, { onClick: onDismiss }), children: _jsxs(Box, { display: "grid", gridTemplateColumns: "auto 1fr", gap: theme => theme.spacing.m, children: [_jsx(Box, { gridRow: "1", gridColumn: "1", children: t.versionLabel }), _jsx(Box, { gridRow: "1", gridColumn: "2", children: _jsx(Text, { fontWeight: "bold", children: VERSION }) }), _jsx(Box, { gridRow: "2", gridColumn: "1", children: t.appServerVersionLabel }), _jsx(Render, { render: () => {
                        const state = loading.state;
                        switch (state) {
                            case "not-started":
                            case "is-running":
                                return (_jsx(Box, { gridRow: "2", gridColumn: "2", children: _jsx(Spinner, { size: SpinnerSize.xSmall }) }));
                            case "has-finished":
                                return (_jsx(Box, { gridRow: "2", gridColumn: "2", children: _jsxs(Text, { fontWeight: "bold", children: [" ", loading.data.appServerVersion] }) }));
                            case "failed":
                                return (_jsx(Box, { gridRow: "3", gridColumn: "1 / -1", children: _jsx(ApiErrorMessage, { message: loading.error }) }));
                            default:
                                assertNever(state);
                        }
                    } }), _jsx(Box, { gridRow: "4", gridColumn: "1 / -1", children: t.copyright(today().getFullYear()) }), _jsx(Box, { gridRow: "5", gridColumn: "1 / -1", children: _jsx(DefaultButton, { onClick: clearAllCaches, children: t.clearCache }) })] }) }));
};
export const AboutDialog = connect(mapStateToProps, actions)(AboutDialogBase);
